module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/isarray/index.js
 ** module id = 510
 ** module chunks = 0
 **/